import React, { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

function AnamnesiFamiliariComponent({ anamnesiFamiliari, cartellaSocialeId }) {
  const apiToken = useContext(TokenContext);
  const [showModalAdd, setshowModalAdd] = useState(false);
  const [showModalModify, setshowModalModify] = useState(false);

  const [error, setError] = useState("");
  const initialFormData = {
    cartellaSocialeId: cartellaSocialeId,
    dataCreazione: "",
    descrizione: "",
  };
  const [formData, setFormData] = useState(initialFormData);

  const [parmCartellaSocialeId, setParmCartellaSocialeId] = useState("");

  useEffect(() => {
    setParmCartellaSocialeId(cartellaSocialeId);
  }, [cartellaSocialeId]);

  const resetFormFields = () => {
    setFormData(initialFormData);
    setError("");
  };

  const toggleModalAdd = () => {
    setshowModalAdd(!showModalAdd);
    resetFormFields();
  };

  const toggleModalModify = () => {
    setshowModalModify(!showModalModify);
  };

  const handleCloseModalAdd = () => {
    setshowModalAdd(false);
    resetFormFields();
  };

  const handleCloseModalModify = () => {
    setshowModalModify(false);
    resetFormFields();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditorChange = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      descrizione: value, // Aggiorna il valore dell'editor nel formData
    }));
  };

  const showAdd = () => {
    setshowModalAdd(true);
  };

  const handleDelete = (recordId) => {
    const confirmDelete = window.confirm(
      "Sei sicuro di voler eliminare questo record?"
    );

    if (confirmDelete) {
      // Chiamata API per eliminare il record
      Repo.DelAnamnesiFamiliare(apiToken, recordId)
        .then((response) => {
          if (response.status === 204) {
            // Aggiorna lo stato o effettua altre azioni dopo l'eliminazione
            // Ad esempio, puoi ricaricare i dati o aggiornare il componente.
            window.location.reload();
          }
        })
        .catch((error) => {
          Repo.handleApiError(error, setError);
        });
    }
  };

  const handleModify = (recordId, ogg) => {
    setshowModalModify(true);
    formData.id = recordId;
    formData.dataCreazione = ogg.dataCreazione;
    formData.cartellaSocialeId = cartellaSocialeId;
    formData.descrizione = ogg.descrizione;
    setError("");
    bodyModify();
  };

  const handleSave = () => {
    const { descrizione } = formData;

    const data = {
      cartellaSocialeId: parmCartellaSocialeId,
      descrizione,
    };

    Repo.AddAnamnesiFamiliare(apiToken, JSON.stringify(data))
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        Repo.handleApiError(error, setError);
      });

    resetFormFields();
  };

  const handleUpd = (id) => {
    const { dataCreazione, descrizione } = formData;

    const data = {
      id: id,
      cartellaSocialeId,
      dataCreazione,
      descrizione,
    };

    Repo.UpdAnamnesiFamiliare(apiToken, JSON.stringify(formData))
      .then((response) => {
        if (response.status === 200) {
          setshowModalAdd(false);
          window.location.reload();
        }
      })
      .catch((error) => {
        // Gestione dell'errore
        Repo.handleApiError(error, setError);
      });

    // resetFormFields();
  };

  const bodyAdd = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Inserisci una nuova anamnesi familiare per l'assistito
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={parmCartellaSocialeId}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="descrizione">Note:</label>

              <ReactQuill
                theme="snow"
                name="descrizione"
                id="descrizione"
                value={formData.descrizione} // Assicurati che il nome del campo corrisponda
                onChange={handleEditorChange}
                style={{
                  width: "100%",
                  height: "300px",
                  paddingBottom: "50px",
                }}
              />
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleSave()}
                >
                  Salva
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bodyModify = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Inserisci una nuova valutazione familiare per l'assistito ID{" "}
          {cartellaSocialeId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <input
                type="hidden"
                id="cartellaSocialeId"
                name="cartellaSocialeId"
                value={cartellaSocialeId}
                onChange={handleChange}
              />
            </div>
            <div>
              <input
                type="hidden"
                id="dataCreazione"
                name="dataCreazione"
                value={formData.dataCreazione}
                onChange={handleChange}
              />
            </div>
            <div className="col-lg-12">
              <label htmlFor="descrizione">Note:</label>
              <ReactQuill
                theme="snow"
                name="descrizione"
                id="descrizione"
                value={formData.descrizione} // Assicurati che il nome del campo corrisponda
                onChange={handleEditorChange}
                style={{
                  width: "100%",
                  height: "300px",
                  paddingBottom: "50px",
                }}
              />
            </div>

            <div className="d-flex justify-content-end clearfix">
              {!error && (
                <button
                  className="btn btn-primary btn-salva"
                  type="button"
                  onClick={() => handleUpd(formData.id)}
                >
                  Modifica
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione:</b> {error}.
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="col-lg-12">
      <div className="card-wrapper card-space">
        <div className="card card-bg no-after card-big roundedCustom">
          <div className="etichetta">
            <svg className="icon icon-primary">
              <use href={`${iconSprite}#it-plus`}></use>
            </svg>
            <span>
              {" "}
              <a
                className="text-decoration-none"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  showAdd();
                }}
              >
                Aggiungi
              </a>
            </span>
          </div>
          <div className="card-body" key="anamnesiFamiliari">
            <div className="row">
              <div className="col-lg-9">
                <h5>Dettagli Anamnesi Familiari</h5>
              </div>
            </div>
            {anamnesiFamiliari && anamnesiFamiliari.length > 0 ? (
              anamnesiFamiliari.map((anamnesi) => (
                <div key={anamnesi.id}>
                  <div className="d-flex justify-content-between">
                    <div>
                      <p>
                        {" "}
                        Data: <strong>{anamnesi.dataCreazione}</strong>
                      </p>
                    </div>
                    <div>
                      <div>
                        <button
                          className="btn btn-outline-primary p-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Modifica"
                          onClick={() => handleModify(anamnesi.id, anamnesi)}
                        >
                          <svg className="icon icon-primary">
                            <use href={`${iconSprite}#it-pencil`} />
                          </svg>
                        </button>

                        <button
                          className="btn btn-outline-danger p-1 ml-1"
                          type="button"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Elimina"
                          onClick={() => handleDelete(anamnesi.id)}
                        >
                          <svg className="icon icon-danger">
                            <use href={`${iconSprite}#it-delete`} />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    dangerouslySetInnerHTML={{ __html: anamnesi.descrizione }}
                  />

                  {/* Altri dettagli dell'anamnesi familiari */}

                  <hr />
                </div>
              ))
            ) : (
              <>Non ci sono anamnesi familiari disponibili.</>
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={toggleModalAdd}
        isOpen={showModalAdd}
        header="Aggiungi"
        body={bodyAdd()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalAdd}
      />

      <ModalComponent
        toggleModal={toggleModalModify}
        isOpen={showModalModify}
        header="Modifica"
        body={bodyModify()}
        buttonDeny="Chiudi"
        onClose={handleCloseModalModify}
      />
    </div>
  );
}

export default AnamnesiFamiliariComponent;
